import React from 'react';
import { SetFormStaticData, setFormData } from "./../../../lib/utils";
import { getFEWalletParams } from "./../../../../platform.pay.config";
import translate from "./../../../lib/translate/TranslateJs";


class SetForm extends React.Component {
    constructor(props) {
        super(props);

        this.timer = null;
        this.forceTimer = null;
        this.formStaticData = new SetFormStaticData();
    }
    commonState = {
        step: 1,
        depositDateTime: "",
        submitDisabled: true
    }
    didMount() {
        this.setCurrFormData(this.formStaticData.getData());

        // 30 秒后强制清除表单默认值设置事件
        this.forceTimer = setTimeout(() => {
            clearInterval(this.timer);
        }, 30000);
    }
    didUpdate(prevProps, prevState) {
        if (prevState.step !== this.state.step) {
            if (this.state.step === 1) {
                this.setCurrFormData(this.formStaticData.getData());
                this.setSubmitButtonStatus();
            }
            if (this.state.step * 1 !== 1) {
                getFEWalletParams()?.withdrawalHeader(false)
            } else {
                getFEWalletParams()?.withdrawalHeader(true)
            }
            this.props.setStep(this.state.step);
        }
    }
    willUnmount() {
        clearInterval(this.timer);
        clearTimeout(this.forceTimer);
    }
    // 对于是否需要额外调用按钮状态更新，取决于更改后的表单错误状态是否可以实时获取到
    setSubmitButtonStatus = () => {
        this.setState({
            submitDisabled:
                this.props.submitDisabled ||
                    (this.formInstance ?
                        !this.formInstance.getFieldsError()
                            .filter((v) => (
                                v.name[0] && v.name[0].substr(-5) !== "other"
                            ))
                            .every((v) => {
                                const Val = this.formInstance.getFieldValue(v.name);
                                return Val !== "" && Val !== undefined && !v.errors.length
                            }) :
                                true)
        })
    }
    setCurrFormData = (data) => {
        setFormData(() => (this.formInstance), this.timer, data);
    }
    setStep = (step) => {
        this.setState({step});
    }
    setFormInstance = (form) => {
        this.formInstance = form;
    }
    setDepositTime = (time) => {
        if (typeof time === "string" && !~time.indexOf("T")) {
            return;
        }
        this.setState({depositDateTime: time.split('T').join(' ').split('.')[0]});
    }
    clearDateTime = () => {
        this.setState({depositDateTime: ""});
    }
    goHome = () => {
        // getFEWalletParams()?.toggleHideWithdrawHeader(true)
        getFEWalletParams()?.BackClick()
        this.setState({ step: 1 }, () => {
            this.formInstance.setFieldValue("money", "");
        });
    }
    goBack = () => {
        getFEWalletParams()?.toggleHideWithdrawHeader(true)
        this.setState({ step: 1 }, () => {
            this.formInstance.setFieldValue("money", "");
        });
    }
}

export default SetForm;
